import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ChartComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoolsTable"] */ "/app/components/PoolsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopPools"] */ "/app/components/TopPools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Group","Value","Trigger","Icon","displayName","ScrollUpButton","ScrollDownButton","Portal","Content","Viewport","Label","Item","ItemIndicator","ItemText","Separator"] */ "/app/node_modules/@radix-ui/react-select/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
